<template>
  <div
    class="frisbuy-popup-transition-wrapper"
    :class="{ 'frisbuy-popup-transition-wrapper--open': isPopupOpen }"
    v-touch:swipe.self="(direction) => $emit('swipe', direction)"
  >
    <transition name="popup-slider">
      <slot></slot>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-popup-transition-wrapper {
  // NOTE: this style for popup animation
  // width: unset;
  // height: 0;
  // aspect-ratio: 9 / 16;

  width: 100%;
  height: 0;
  margin: 0 auto;

  overflow: hidden;
  position: absolute;
  // top: 40px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  border-radius: 10px;

  transition: width 1s, height 1s;

  @media screen and (min-width: 768px) {
    // HACK: 4px to cover the slide pixels on the sides
    width: calc((var(--frisbuy-story-slide-height) + 4px) * (9 / 16));
  }

  &.frisbuy-popup-transition-wrapper--open {
    @media screen and (min-width: 768px) {
      height: var(--frisbuy-story-slide-height);
    }

    @media screen and (max-width: 767px) {
      // NOTE: this style for popup animation
      // width: unset;

      height: 100%;
    }
  }

  @media screen and (max-width: 767px) {
    max-width: 100vw;
    aspect-ratio: 9 / 16;
    bottom: 0;

    border-radius: 0;

    margin: 0 auto;
  }
}

.popup-slider-enter-active,
.popup-slider-leave-active {
  transition: transform 350ms ease-in;
}

.popup-slider-enter-from,
.popup-slider-leave-to {
  transform: translateY(100%);
}
</style>

<script>
export default {
  emits: ["swipe"],

  props: {
    isPopupOpen: {
      type: Boolean,
      require: true,
    },
  },

  data() {
    return {};
  },
};
</script>
